import { render, staticRenderFns } from "./FlyerContainer.vue?vue&type=template&id=2c10193d"
import script from "./FlyerContainer.vue?vue&type=script&lang=js"
export * from "./FlyerContainer.vue?vue&type=script&lang=js"
import style0 from "./FlyerContainer.vue?vue&type=style&index=0&id=2c10193d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports